import type {WhatsappAction} from 'src/action-creators/whatsapp';
import type {WhatsappState} from 'src/types/whatsapp';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';

import {
  RECEIVE_WHATSAPP_INFO,
  UPDATE_WHATSAPP_INFO,
  UPDATE_NODE_SCHEDULE,
  RESET,
} from 'src/action-creators/whatsapp';


const initialState = {
  to_number: null,
  from_number: null,
  external_source_id: null,
  selected_template: null,
  variables: {},
  body: '',
  sender_category: null,
  ...getDefaultNodeScheduleState({
    blackout_action: 'SEND_BEFORE',
  }),
} as const;

export default (
  state: WhatsappState | null | undefined = initialState,
  action: WhatsappAction,
): WhatsappState => {
  switch (action.type) {
    case UPDATE_WHATSAPP_INFO:
      // @ts-expect-error - TS2322 - Type '{ body?: unknown | null | undefined; external_source_id?: string | null | undefined; from_number?: string | null | undefined; to_number?: string | null | undefined; sender_category?: string | null | undefined; ... 15 more ...; skip_frequency_check?: boolean; }' is not assignable to type 'WhatsappState'.
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_WHATSAPP_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NODE_SCHEDULE:
      // @ts-expect-error - TS2322 - Type '{ date_type?: string; date_value?: string; time_type?: string; time_value?: string; offset?: number; date_field?: string | null | undefined; time_field?: string | null | undefined; dateOffset?: Offset; ... 12 more ...; selected_template?: { id: string | null | undefined; } | null | undefined; }' is not assignable to type 'WhatsappState'.
      return {
        ...state,
        ...action.payload,
      };
    case RESET:
      return {...initialState};
  }
  // @ts-expect-error - TS2322 - Type 'WhatsappState | null' is not assignable to type 'WhatsappState'.
  return state;
};
